// AnimatedBackground.js — the site-wide backdrop behind all page content.
// Static on purpose: the old animated, blurred aurora cost real paint time on
// phones (Core Web Vitals). Three soft glows in the palette's colours (theme.js) give the same feel.
// (Name kept so App.js imports stay stable.)

import React from "react";
import { Box } from "@mui/material";
import { GLOWS } from "../theme";

export default function AnimatedBackground() {
  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        background: [
          `radial-gradient(900px 600px at 8% -5%, ${GLOWS[0]}, transparent 70%)`,
          `radial-gradient(800px 600px at 100% 30%, ${GLOWS[1]}, transparent 70%)`,
          `radial-gradient(700px 500px at 30% 110%, ${GLOWS[2]}, transparent 70%)`,
        ].join(", "),
      }}
    />
  );
}
